import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import invariant from 'tiny-invariant';
import applyRules from '@sprinx/pricing-core/applyRules';
import useCancellablePromise from '@sprinx/react-hooks/useCancellablePromise';
import PricingRulesContext from '../PricingRulesProvider/PricingRulesContext';

function useDummyHook() {
  return React.useCallback(function () {
    return Promise.resolve(null);
  }, []);
}

export default function useApplyPricingRulesHandler() {
  var pricingRulesCtx = React.useContext(PricingRulesContext);
  invariant(pricingRulesCtx, "Don't use 'useApplyPricingRulesHandler' outside of <PricingProvider>");
  var currency = pricingRulesCtx.currency,
      decimalPrecision = pricingRulesCtx.decimalPrecision,
      noTaxPrices = pricingRulesCtx.noTaxPrices,
      priceGroup = pricingRulesCtx.priceGroup,
      productFinderHook = pricingRulesCtx.productFinderHook,
      region = pricingRulesCtx.region,
      rules = pricingRulesCtx.rules,
      strategies = pricingRulesCtx.strategies;
  var useProductFinder = productFinderHook || useDummyHook;
  var productFinder = useProductFinder();
  var cancellablePromise = useCancellablePromise();
  return React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(applyRulesCtxPartial, cart) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", cancellablePromise(applyRules(_extends({}, applyRulesCtxPartial, {
                cart: cart,
                decimalPrecision: decimalPrecision,
                currency: currency,
                noTaxPrices: noTaxPrices,
                productFinder: productFinder,
                priceGroup: priceGroup,
                region: region,
                rules: rules,
                strategies: strategies
              }))));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [cancellablePromise, currency, decimalPrecision, noTaxPrices, productFinder, priceGroup, region, rules, strategies]);
}